export const BRAND = "#1876DB";
export const BRAND_LIGHT = "#056DFF";
export const BRAND_DARK = "#164DB4";
export const BRAND_DARKEST = "#032765";

export const ACCENT_PRIMARY = "#164DB4";
export const ACCENT_PRIMARY_LIGHT = "#97C9FA";
export const ACCENT_PRIMARY_LIGHTEST = "#DCF6FF";
export const ACCENT_PRIMARY_LIGHTEST_HOVER = "#E6FBFF";
export const ACCENT_PRIMARY_LIGHTEST_PRESSED = "#DCEFF8";

export const ACCENT_SECONDARY = "#B36200";
export const ACCENT_SECONDARY_LIGHT = "#FFC165";
export const ACCENT_SECONDARY_LIGHTEST = "#FDF0E5";
export const ACCENT_SECONDARY_LIGHTEST_HOVER = "#FFF6EB";
export const ACCENT_SECONDARY_LIGHTEST_PRESSED = "#F5EAE1";

export const ACCENT_TERTIARY = "#0080A7";
export const ACCENT_TERTIARY_LIGHT = "#7BDCEF";

export const SUCCESS = "#0C8821";
export const SUCCESS_LIGHT = "#63E1A3";
export const SUCCESS_LIGHTEST = "#F0FFF8";

export const ERROR = "#CE3827";
export const ERROR_LIGHT = "#DB3B29";
export const ERROR_LIGHTEST = "#FFF3F1";
export const ERROR_DARK = "#AC2F20";

export const NOTICE = "#C74800";
export const NOTICE_LIGHT = "#FBA677";
export const NOTICE_LIGHTEST = "#FFF8EC";

export const BLACK = "#000000";

export const WHITE = "#FFFFFF";

export const GRAY = "#949494";
export const GRAY_LIGHT = "#E6E6E6";
export const GRAY_LIGHTEST = "#F5F5F5";
export const GRAY_LIGHTEST_HOVER = "#FBFBFB";
export const GRAY_LIGHTEST_PRESSED = "#EFEFEF";
export const GRAY_DARK = "#272D39";

export const TEXT_PRIMARY = "#1A1F2C";
export const TEXT_SECONDARY = "#62646A";
